import { accessSteps } from "@/mocks/home";

export default function StepsSection() {
  return (
    <section id="steps" className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs md:text-sm">
            <i className="ri-route-line" />
            访问步骤
          </span>
          <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
            四步找到可用入口
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            不管是第一次来，还是收藏的地址突然失效，按下面四步操作，就能稳定地重新找到 91免费 的可用入口。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {accessSteps.map((item, index) => (
            <div
              key={item.id}
              className="relative flex gap-4 rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <span className="shrink-0 w-12 h-12 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading font-bold text-lg">
                {item.step}
              </span>
              <div className="flex-1">
                <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-sm text-foreground-700 leading-relaxed">{item.desc}</p>
              </div>
              {index === 0 && (
                <span className="absolute top-4 right-4 text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-900">
                  最关键
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}